export enum ReportSecondaryTabs {
  Transactions = 'Transactions',
  AccountsBalance = 'Accounts Balance',
}
